import {
  PROFILE_ERROR,
  PROFILE_SUCCESS,
  EDIT_PROFILE,
  RESET_PROFILE_FLAG,
  PROFILE_CHANGE_PASSWORD_SUCCESS,
  PROFILE_CHANGE_PASSWORD_FAIL,
  EDIT_PROFILE_SUCCESS,
  CARDS_SUCCESS,
} from "./actionTypes";

const initialState = {
  error: "",
  success: "",
  user: null,
  usersList: [],
  teamsList: [],
  cards: null,
  isFetchingCards: true,
};

const Profile = (state = initialState, action) => {
  switch (action.type) {
    case EDIT_PROFILE:
      state = { ...state };
      break;

    case PROFILE_SUCCESS:
      state = {
        ...state,
        success: true,
        user: { ...state.user, ...action.payload },
      };
      break;
    case EDIT_PROFILE_SUCCESS:
      state = {
        ...state,
        editProfileSuccess: true,
        user: { ...state.user, ...action.payload.user },
      };
      break;
    case CARDS_SUCCESS:
      state = {
        ...state,
        cards: action.payload.data,
        isFetchingCards: false,
      };
      break;
    case PROFILE_ERROR:
      state = {
        ...state,
        error: action.payload.message,
      };
      break;
    case PROFILE_CHANGE_PASSWORD_SUCCESS:
      state = {
        ...state,
        passwordChangeSuccess: true,
      };
      break;

    case PROFILE_CHANGE_PASSWORD_FAIL:
      state = {
        ...state,
        passwordChangeFail: action.payload,
      };
      break;
    case RESET_PROFILE_FLAG:
      state = {
        ...state,
        success: null,
        passwordChangeSuccess: false,
        editProfileSuccess: false,
        passwordChangeFail: false,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default Profile;
